import script from "./OpenCities.vue?vue&type=script&lang=ts&setup=true&name=AttachmentList"
export * from "./OpenCities.vue?vue&type=script&lang=ts&setup=true&name=AttachmentList"

const __exports__ = script;

export default __exports__